import * as React from 'react';
import { ArticleHeading0 } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface ISideBarProps {
  title: string;
  header?: React.ReactNode;
  footer?: React.ReactNode;
}

export const SideBar: React.FC<React.PropsWithChildren<ISideBarProps>> = props => {
  const { title, header, children, footer } = props;

  return (
    <div className={styles['container']}>
      <div className={styles['header']}>{header}</div>
      <div className={styles['title']}>
        <ArticleHeading0>{title}</ArticleHeading0>
      </div>
      <div className={styles['content']}>{children}</div>
      <div className={styles['footer']}>{footer}</div>
    </div>
  );
};

SideBar.displayName = 'SideBar';
